/* eslint-disable prefer-destructuring */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-shadow */
/* eslint-disable jsx-control-statements/jsx-use-if-tag */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import './profile.scss'
import { isEmpty } from 'AccountsUtils'

import { Button } from '@cleartrip/bento/components/Button'
import { Spacer } from '@cleartrip/bento/components/Spacing'
import moment from 'moment'
import { errorConfig } from '../../newComponents/UnifiedLogin/screens/errorConfig'
import { onlyAlphabetsSpaceRegex, invokeCustomEvent } from '../../utils'
import { submitPersonalDetails } from '../../pages/Trips/trips.helper'
import BentoRadio from '../../components/bentoradio'
import Field from '../../components/Form'
import Chip from '../../components/Chip/index'

const Handlepiclick = ({
  setIsEOpaque = () => { },
  setIsGOpaque = () => { },
  setIsMOpaque = () => { },
  setIsLIOpaque = () => { },
  userDetail,
  setUserDetail,
  setToastMessagex = () => { }
}) => {
  const [isPIEditable, setIsPIEditable] = useState(true)
  const [temp, setTemp] = useState({
    firstname: '',
    lastname: '',
    birthday: '',
    anniversaryDate: '',
    gen: '',
    maritalStatus: ''
  })
  const [width, setWidth] = useState('')
  const [userName, setUserName] = useState({
    firstname: '',
    lastname: '',
    birthday: '',
    anniversaryDate: '',
    gen: '',
    maritalStatus: ''
  })
  const [button, setButton] = useState('Add')
  const [gender, setGender] = useState('')
  const [apiError, setApiError] = useState('')
  const [loading, setLoading] = useState(false)
  const [maritalStatus, setMaritalStatus] = useState('')
  const genderClickHandler = gender => {
    setApiError('')
    setGender(gender)
    setUserName({
      ...userName,
      gen: gender
    })
  }

  useEffect(() => {
    if (isEmpty(userDetail)) {
      return
    }
    const { travellerDetails } = userDetail
    const { personalDetails } = travellerDetails[0]
    const {
      firstName,
      lastName,
      dateOfBirth,
      anniversaryDate,
      title,
      maritalStatus
    } = personalDetails
    if (!isEmpty(dateOfBirth)) {
      const finalDate = moment(dateOfBirth).format('DD-MM-YYYY')
      setTemp(prevState => {
        return {
          ...prevState,
          birthday: finalDate
        }
      })
      setUserName(prevState => {
        return {
          ...prevState,
          birthday: finalDate
        }
      })
    }
    if (
      !isEmpty(anniversaryDate) &&
      !isEmpty(maritalStatus) &&
      maritalStatus === 'MARRIED'
    ) {
      const finalDate = moment(anniversaryDate).format('DD-MM-YYYY')
      setTemp(prevState => {
        return {
          ...prevState,
          anniversaryDate: finalDate
        }
      })
      setUserName(prevState => {
        return {
          ...prevState,
          anniversaryDate: finalDate
        }
      })
    }

    if (!isEmpty(firstName)) {
      setTemp(prevState => {
        return {
          ...prevState,
          firstname: firstName
        }
      })
      setUserName(prevState => {
        return {
          ...prevState,
          firstname: firstName,

        }
      })
    }
    if (!isEmpty(lastName)) {
      setTemp(prevState => {
        return {
          ...prevState,
          lastname: lastName
        }
      })
      setUserName(prevState => {
        return {
          ...prevState,
          lastname: lastName
        }
      })
    }

    if (!isEmpty(maritalStatus)) {
      setTemp(prevState => {
        return {
          ...prevState,
          maritalStatus
        }
      })
      setUserName(prevState => {
        return {
          ...prevState,
          maritalStatus
        }
      })
      setMaritalStatus(maritalStatus)
    }
    if (!isEmpty(title)) {
      setTemp(prevState => {
        return {
          ...prevState,
          gen: title
        }
      })
      setUserName(prevState => {
        return {
          ...prevState,
          gen: title
        }
      })
      setGender(title)
    }
  }, [userDetail])

  const handleChangeAnniversaryDate = (e, key) => {
    setApiError('')
    const value = e.target.value
    let modifiedValue = value
    if (value.length === 2 || value.length === 5) {
      modifiedValue = `${value}-`
    }

    setUserName(prevState => {
      if (prevState.anniversaryDate.length > value.length) {
        return {
          ...prevState,
          anniversaryDate: value
        }
      }
      return {
        ...prevState,
        anniversaryDate: modifiedValue
      }
    })
  }

  const maritalStatusClickHandler = status => {
    setMaritalStatus(status)
    if (status === 'SINGLE') {
      setUserName(prevState => {
        return {
          ...prevState,
          anniversaryDate: '',
          maritalStatus: status
        }
      })
    } else {
      setUserName(prevState => {
        return {
          ...prevState,
          maritalStatus: status
        }
      })
    }
  }

  const handleChangeDob = (e, key, sanitizeFn) => {
    setApiError('')
    const value = e.target.value
    let modifiedValue = value

    if (value.length === 2 || value.length === 5) {
      modifiedValue = `${value}-`
    }

    setUserName(prevState => {
      if (prevState.birthday.length > value.length) {
        return {
          ...prevState,
          birthday: value
        }
      }
      return {
        ...prevState,
        birthday: modifiedValue
      }
    })
  }
  const handlePIClick = () => {
    setIsPIEditable(false)
    setIsEOpaque(true)
    setIsGOpaque(true)
    setIsMOpaque(true)
    setIsLIOpaque(true)
  }
  function convertToRequiredDateFormat(date) {
    const Regex = /[0-9][0-9]-[0-9][0-9]-[0-9][0-9][0-9][0-9]/gm

    if (date === '' || date === null) {
      return null
    }
    if (date.length !== 10 || !Regex.test(date)) {
      return 'Invalid date'
    }
    const value = moment(date, 'DD-MM-YYYY')
    const today = moment().format('DD-MM-YYYY')
    const todayDate = moment(today, 'DD-MM-YYYY')

    if (todayDate.isBefore(value)) {
      return 'Invalid date'
    }

    if (value.format('YYYY-MM-DD') === 'Invalid date') {
      return 'Invalid date'
    }
    return `${value.format('YYYY-MM-DD')}T00:00:00`
  }

  const formSubmitHandler = async () => {
    const finalBirthday = convertToRequiredDateFormat(userName?.birthday)
    if (finalBirthday === 'Invalid date') {
      setApiError('Please enter a valid date ')
      return
    }
    const finalAnniversaryDate = convertToRequiredDateFormat(
      userName?.anniversaryDate
    )
    if (finalAnniversaryDate === 'Invalid date') {
      setApiError('Please enter a valid date ')
      return
    }

    setApiError('')
    try {
      setApiError('')
      const payload = {
        personalData: {
          firstName: userName?.firstname,
          lastName: userName?.lastname,
          maritalStatus:
            userName?.maritalStatus === '' ? null : userName?.maritalStatus,
          title: userName?.gen === '' ? null : userName?.gen,
          dateOfBirth: finalBirthday,
          anniversaryDate: finalAnniversaryDate
        }
      }
      setLoading(true)
      const submitFormApiResponse = await submitPersonalDetails(payload)
      const { status, error } = submitFormApiResponse || {}
      if (status === 200) {
        invokeCustomEvent('CLEVERTAP_PROFILE', { type: 'profileUpdate' })
        setToastMessagex('Personal information has been updated')
        setApiError('')
        setTemp(userName)
        setIsPIEditable(true)
        setIsEOpaque(false)
        setIsGOpaque(false)
        setIsMOpaque(false)
        setIsLIOpaque(false)
        setLoading(false)
      } else {
        const { response = { data: {} } } = error || {}
        const { data = {} } = response
        const { message } = data
        const errRes = errorConfig[message] || errorConfig.default
        setApiError(errRes)
      }
      setLoading(false)
    } catch (ex) {
      console.error(ex)
      setLoading(false)
    }
  }
  const nameChangeHandler = (e, type) => {
    setApiError('')
    let val = e.target.value
    const reg = /[^,.a-zA-Z0-9\s]/
    if (reg.test(val)) {
      val = val.replace(/[^,.a-zA-Z0-9\s]/g, '')
      return val
    }

    if (!isEmpty(val) && !onlyAlphabetsSpaceRegex.test(val)) {
      if (type === 'FN') {
        setUserName({
          ...userName,
          firstname: val
        })
      } else {
        setUserName({
          ...userName,
          lastname: val
        })
      }
      return
    }
    if (type === 'FN') {
      setUserName({
        ...userName,
        firstname: val.trim().length === 0 ? '' : val
      })
    } else {
      setUserName({
        ...userName,
        lastname: val.trim().length === 0 ? '' : val
      })
    }
  }

  const handleCancel = () => {
    setApiError('')
    setIsPIEditable(true)
    setIsGOpaque(false)
    setIsMOpaque(false)
    setIsEOpaque(false)
    setIsLIOpaque(false)
  }
  const genderString = temp.gen !== '' ? temp.gen : ''
  const firstNameString = temp.firstname !== '' ? temp.firstname : ''
  const lastNameString = temp.lastname !== '' ? temp.lastname : ''
  const finalString =
    genderString === '' && firstNameString === '' && lastNameString === '' ?
      'Not Provided' :
      `${genderString} ${firstNameString} ${lastNameString}`

  useEffect(() => {
    if (
      finalString === 'Not Provided' &&
      temp?.birthday === '' &&
      temp?.maritalStatus === '' &&
      !temp?.birthday &&
      !temp?.maritalStatus
    ) {
      setButton('Add')
    } else {
      setButton('Edit')
    }
  }, [temp])

  return (
    <div>
      {isPIEditable ? (
        <>
          <div className="flex flex-row">
            <div className="fs-5 fw-600 w-600">Personal information</div>
            <div className="heading7">
              <a onClick={handlePIClick}>{button}</a>
            </div>
          </div>

          <div className="mt-6">
            <div>
              <div className="fs-2 c-grey-title ">Full Name</div>
              {finalString !== 'Not Provided' ? (
                <span className="fs-4 " style={{ color: '#1A1A1A' }}>
                  {finalString}
                </span>
              ) : (
                <span className="fs-4 " style={{ color: '#B3B3B3' }}>
                  Not Provided
                </span>
              )}
              <div className="dotted_line" />
            </div>
            <div>
              <div className="fs-2 c-grey-title mt-5">Birthdate</div>
              <div>
                {temp.birthday !== '' ? (
                  <span className="fs-4 " style={{ color: '#1A1A1A' }}>
                    {temp.birthday}
                  </span>
                ) : (
                  <span className="fs-4 " style={{ color: '#B3B3B3' }}>
                    Not Provided
                  </span>
                )}
              </div>
              <div className="dotted_line" />
            </div>
            <div>
              <div className="fs-2 c-grey-title mt-5">Marital Status</div>

              {temp.maritalStatus !== '' ? (
                temp.maritalStatus === 'SINGLE' ? (
                  <span className="fs-4 ">SINGLE</span>
                ) : (
                  <>
                    <span className="fs-4 ">MARRIED</span>
                    <div className="dotted_line" />
                  </>
                )
              ) : (
                <span className="fs-4 " style={{ color: '#B3B3B3' }}>
                  Not Provided
                </span>
              )}
            </div>
            <div>
              {temp.maritalStatus === 'MARRIED' && (
                <>
                  <div className="fs-2 c-grey-title mt-5">Anniversary</div>
                  <div>
                    {temp.anniversaryDate !== '' ? (
                      <span className="fs-4 " style={{ color: '#1A1A1A' }}>
                        {temp.anniversaryDate}
                      </span>
                    ) : (
                      <span className="fs-6 " style={{ color: '#B3B3B3' }}>
                        Not Provided
                      </span>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      ) : (
        <div className="flex flex-column">
          <div className="fw-600 fs-5">
            <span>Add personal information</span>
          </div>
          <div className="mt-6 l-16  flex ">
            <div className="mr-3">
              <Chip
                isSelected={gender === 'Mr'}
                onClick={() => genderClickHandler('Mr')}
                title="Mr."
              />
            </div>
            <div className="mr-3">
              <Chip
                isSelected={gender === 'Ms'}
                onClick={() => genderClickHandler('Ms')}
                title="Ms."
              />
            </div>
            <div className="mr-3">
              <Chip
                isSelected={gender === 'Mrs'}
                onClick={() => genderClickHandler('Mrs')}
                title="Mrs."
              />
            </div>
          </div>
          <div className="mt-6 flex flex-column color-neutral-700 fs-14 lh-18 mb-10">
            <Field
              label="First name"
              id="firstAndMiddleName"
              wrapperClassName="w-328 br-6-imp"
              type="text"
              value={userName.firstname}
              maxLimit={32}
              onChange={e => nameChangeHandler(e, 'FN')}
            />

            <div className="mt-6" />
            <Field
              label="Last name"
              wrapperClassName="w-328 br-6-imp"
              type="text"
              value={userName.lastname}
              maxLimit={32}
              onChange={e => nameChangeHandler(e, 'LN')}
            />

            <Field
              type="text"
              label="Birthday DD-MM-YYYY"
              wrapperClassName="mt-6 w-328 br-6-imp"
              maxLength={10}
              onFocus={() => {
                setWidth(0)
              }}
              onBlur={() => {
                setWidth('')
              }}
              onChange={e => {
                handleChangeDob(e, 'dob')
              }}
              value={userName?.birthday || ''}
              style={{ width: userName.birthday ? '' : width }}
            />

            <div className="mt-6 fs-16 fw-600">
              <span> Add Marital status</span>
              <Spacer classname="m-10" />

              <div className="mt-6">
                <BentoRadio
                  name="marital"
                  onChange={() => maritalStatusClickHandler('SINGLE')}
                  checked={maritalStatus === 'SINGLE'}
                >
                  <span className=" ml-10 fs-16 lh-24 color-neutral-700">
                    Single
                  </span>
                </BentoRadio>
              </div>

              <div className="mt-6">
                <BentoRadio
                  name="marital"
                  onChange={() => maritalStatusClickHandler('MARRIED')}
                  checked={maritalStatus === 'MARRIED'}
                >
                  <span className=" ml-10 fs-16 lh-24 color-neutral-700">
                    Married
                  </span>
                </BentoRadio>
              </div>
            </div>
            {maritalStatus === 'MARRIED' && (
              <div className="mt-6">
                <Field
                  type="text"
                  label="Anniversary DD-MM-YYYY"
                  maxLength={10}
                  wrapperClassName="w-328 br-6-imp"
                  onFocus={() => {
                    setWidth(0)
                  }}
                  onBlur={() => {
                    setWidth('')
                  }}
                  onChange={e => {
                    handleChangeAnniversaryDate(e, 'ani')
                  }}
                  value={userName?.anniversaryDate || ''}
                  style={{ width: userName.anniversaryDate ? '' : width }}
                />
              </div>
            )}
            {apiError && (
              <div
                className="fw-500 fs-12 lh-16 mt-2"
                style={{ color: '#CC1414' }}
              >
                {apiError}
              </div>
            )}
            <div className="flex flex-row mt-6">
              <Button
                className="h-10 w-170 br-6-imp"
                type="secondary"
                size="lg"
                full={false}
                onClick={formSubmitHandler}
                busy={loading}
              >
                Save
              </Button>

              <a
                onClick={handleCancel}
                className="fw-600 fs-14 lh-20 ml-12 mt-2"
              >
                Cancel
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
export default Handlepiclick
